
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { searchQuery, locationQuery, titleQuery, searchQueryMax, locationQueryMax, titleQueryMax } from "../utils/Data";
import Card from "./Card";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import { client } from "../client";
import Pagination from "./Pagination";
import { NoResults, ResultsLayout, ResultsSkeleton } from "./ResultsState";
import { feature } from "../utils/features";
import { Jobs } from "../pages";


function JobCardRender(job) {
    return (
      <Card
        key={job._id}
        btnId={job._id}
        title={job.title}
        companyName={job.companyName}
        categories={job.categories}
        city={job.city}
        salary={job.salary}
        postedOn={job.postedOn}
        externalUrl={job.url}
        source={job.source}
        postExpiry={job.postExpiry}
      />
    );
  }


function SearchResults() {

  const [currentPage, setCurrentPage] = useState(0)
  const [maxOpenings, setMaxOpenings] = useState()
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)

    const history = useNavigate();
    const { location, title } = useParams();
    const [jobsArr, setJobsArr] = useState([]);

    function activePageinc (){
      if(currentPage < ((maxOpenings/10)-1))
        { setCurrentPage(currentPage+1); window.scrollTo({ top: 0, behavior: "smooth" }); }
    }
  
    function activePagedec(){
  
      if(currentPage != 0 ) {
        { setCurrentPage(currentPage-1); window.scrollTo({ top: 0, behavior: "smooth" }); }
      }
      
    }  

  useEffect(() => {
       setLoading(true);
       setLoadError(false);
       if(title !="term" && location != "loc"){
        client
        .fetch(searchQuery(title, location,currentPage))
        .then((jobs) => {
          setJobsArr(jobs);
        })
        .catch((err) => {
          console.log(err);
          setLoadError(true);
        })
        .finally(() => setLoading(false));

        client
        .fetch(searchQueryMax(title,location))
        .then((res) => {
            setMaxOpenings(res);
        })
        .catch((err) => console.log(err));

    } else if(location == "loc" && title != "term") {
        client
        .fetch(titleQuery(title,currentPage))
        .then((jobs) => {
            setJobsArr(jobs);
        })
        .catch((err) => {
            console.log(err);
            setLoadError(true);
        })
        .finally(() => setLoading(false));

        client
        .fetch(titleQueryMax(title))
        .then((res) => {
            setMaxOpenings(res);
        })
        .catch((err) => console.log(err));
        
    } else{ 
        client
        .fetch(locationQuery(location,currentPage))
        .then((jobs) => {
            setJobsArr(jobs);
        })
        .catch((err) => {
            console.log(err);
            setLoadError(true);
        })
        .finally(() => setLoading(false));

        client
        .fetch(locationQueryMax(location))
        .then((res) => {
            setMaxOpenings(res);
        })
        .catch((err) => console.log(err));
    }

  }, [currentPage]);




  //Routing
  if(title =="term" && location == "loc"){
      return(
          <Jobs />
      )
  }

  if (loading) {
      return <ResultsSkeleton />;
  }

  if (loadError || jobsArr.length < 1) {
      const hasTitle = title != "term";
      const hasLocation = location != "loc";
      const message = hasTitle && hasLocation
        ? `No jobs match "${title}" in "${location}" right now`
        : hasTitle
          ? `No jobs match "${title}" right now`
          : `No jobs found in "${location}" right now`;
      return <NoResults error={loadError} message={message} />;
  }
  if (feature("modernCards")) {
    return (
      <ResultsLayout
        heading={title != "term" ? `Jobs matching “${title}”${location != "loc" ? ` in ${location}` : ""}` : `Jobs in ${location}`}
        footer={<Pagination currentPage={currentPage} increment={activePageinc} decrement={activePagedec} maxOpenings={maxOpenings} />}
      >
        {jobsArr.map(JobCardRender)}
      </ResultsLayout>
    );
  }
  return (
    <div className="px-4 mx-4">
      <button onClick={() => history(-1)}>
        <div className="text-lg font-semibold text-gray-900 flex flex-row items-center">
          <ChevronLeftIcon className="text-gray-900 h-5 w-5" />
          <h1>Back</h1>
        </div>
      </button>
        <h1 className="font-bold text-xl text-primary font-[Poppins] mt-8 md:px-16 md:mx-16 px-2 mx-2">Showing Results</h1>
      <div className="md:px-16 md:mx-16 px-2 mx-2 mt-8 mb-16 ">
          {
             jobsArr.map(JobCardRender)
          }
          
          </div>
          <Pagination
            currentPage={currentPage}
            increment={activePageinc}
            decrement={activePagedec}
            maxOpenings={maxOpenings}
          />
    </div>
  );
  
}

// Remount on every new search so page number and results reset together
// (the effects inside only re-run on page changes). (UX-008)
function SearchView() {
  const { location, title } = useParams();
  return <SearchResults key={`${location}/${title}`} />;
}

export default SearchView